export enum TestResult {
  Positive,
  Negative,
  Inconclusive
}
